import React, { useState, useEffect } from "react";
import FetchPlaces from "./FetchPlaces";
import "./Cards.css";
import { Link } from "react-router-dom";
import SortingPanel from "./SortingPanel";
import settings, { saveSetting } from "./settings";
import CategoryTitle from "./CategoryTitle";
import { useLanguage } from "./LanguageContext";

function Cards(props) {
  const { t } = useLanguage();
  const [resultsOnPage, setResultsOnPage] = useState(settings.resultsOnPagePlaces);
  const [cardsSize, setCardsSize] = useState(settings.cardsSizePlaces);
  const [isSorted, setIsSorted] = useState(false);

  useEffect(() => {
    setIsSorted(false);
    props.fetchPlaces?.(props.category);
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [props.category]);

  function setResultsOnPageWithSave(value) {
    setResultsOnPage(value);
    saveSetting("resultsOnPagePlaces", value);
  }

  function handleCardsSizeClick() {
    const nextSize = !cardsSize;
    setCardsSize(nextSize);
    saveSetting("cardsSizePlaces", nextSize);
  }

  const hasPlaces = props.places?.length > 0;
  const isLoading = props.loading || (hasPlaces && isSorted === false);

  return (
    <div>
      <CategoryTitle category={props.category} />

      {hasPlaces && props.loading === false ? (
        <SortingPanel
          breadcrumbCategory={props.category}
          resultsOnPage={resultsOnPage}
          setResultsOnPage={setResultsOnPageWithSave}
          cardsSize={handleCardsSizeClick}
          collection={props.places}
          setCollection={props.setPlaces}
          setLoading={props.setLoading}
          target="place"
          setPageNumber={props.setPageNumber}
          isSorted={isSorted}
          setIsSorted={setIsSorted}
        />
      ) : null}

      {isLoading ? (
        <div className="loader"></div>
      ) : (
        <div className={cardsSize ? undefined : "card-deck card-deck-cards"}>
          <FetchPlaces
            places={props.places}
            cardsSize={cardsSize}
            resultsOnPage={resultsOnPage}
            pageNumber={props.pageNumber}
            setPageNumber={props.setPageNumber}
            search={props.search}
          />
        </div>
      )}

      {!hasPlaces && props.loading === false ? (
        <div className="cards-bottom-text">
          <p>{t("empty")}</p>
          <p>{t("changeIt")}</p>
        </div>
      ) : null}

      <div className="cards-bottom-text">
        <Link to="/kontakt">{t("suggestPlace")}</Link>
      </div>
    </div>
  );
}

export default Cards;
